import { useMatch } from 'react-router';

import { LazyTestLink } from 'modules/dev';
import { NegativeBalanceTermsOfServicesDialog } from 'domains/userSettings/screens/Settings/components/GeneralSettings/components/NegativeBalanceTermsOfServicesDialog';
import { TFADialog } from 'modules/tfa/components/TFADialog';
import { featureConfig } from 'modules/common/featureConfig';
import { swaggerUIRoutesConfig } from 'domains/swaggerUI/routes/constants';
import { useIsSMDown } from 'uiKit/Theme/useTheme';

import { Footer } from '../Footer';
import { FreemiumWelcomeDialog } from '../FreemiumWelcomeDialog';
import { Header } from '../Header';
import { MobileHeader } from '../MobileHeader';
import { SideBar } from '../SideBar';
import { StatusTransitionDialogContainer } from './components/StatusTransitionDialogContainer';
import { TopBanners } from '../TopBanners';
import { useDefaultLayoutStyles } from './DefaultLayoutStyles';
import { useTopBannersHeight } from '../TopBannersHeightProvider';

export interface ILayoutProps {
  children?: React.ReactNode;
  hasError?: boolean;
}

export const DefaultLayout = ({ children, hasError = false }: ILayoutProps) => {
  const isSwaggerUIPage = Boolean(
    useMatch(swaggerUIRoutesConfig.swaggerUI.path),
  );

  const { topBannersHeight } = useTopBannersHeight();

  const { classes } = useDefaultLayoutStyles({
    hasGradient: hasError,
    topBannersHeight,
  });
  const isMobileSideBar = useIsSMDown();

  if (isSwaggerUIPage) {
    return <>{children}</>;
  }

  return (
    <>
      <TopBanners />
      <div className={classes.root}>
        <SideBar
          className={classes.sidebar}
          hasMenu
          isMobileSideBar={isMobileSideBar}
        />
        <div className={classes.main}>
          {!hasError && <Header className={classes.header} />}
          <MobileHeader className={classes.mobileHeader} />
          {children}
          <Footer />
          <StatusTransitionDialogContainer />
          <TFADialog />
          <NegativeBalanceTermsOfServicesDialog />
          <FreemiumWelcomeDialog />
          {featureConfig.isDevUiEnabled && <LazyTestLink />}
        </div>
      </div>
    </>
  );
};
